import { useUnit } from 'effector-react';
import { $isConnected, $isConnecting, connect, disconnect } from '../model';

export const useMessageHub = () => {
  const isConnected = useUnit($isConnected);
  const isConnecting = useUnit($isConnecting);

  return {
    isConnected,
    isConnecting,
    connect,
    disconnect,
  };
};
